module.exports = __webpack_public_path__ + "static/media/78_dzz5.cad45fa6.jpg";